import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PortalBackground from '../components/PortalBackground';
import { 
  MessageSquare, 
  Bot, 
  Settings, 
  BarChart3, 
  Zap, 
  Edit, 
  Play, 
  Pause, 
  RotateCcw, 
  CheckCircle, 
  XCircle, 
  AlertCircle,
  User,
  Users,
  Mail,
  Phone,
  Calendar,
  FileText,
  Globe,
  Smartphone,
  Monitor,
  Headphones,
  Mic,
  Video,
  Camera,
  X,
  Check,
  Plus,
  Trash2,
  Eye,
  EyeOff,
  StopCircle,
  SkipBack,
  SkipForward,
  Repeat,
  Shuffle,
  FastForward,
  Rewind,
  Maximize,
  Minimize,
  Move,
  RotateCw,
  RotateCcw as RotateCcwIcon,
  FlipHorizontal,
  FlipVertical,
  ZoomIn,
  ZoomOut,
  Focus,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  CloudSnow,
  CloudLightning,
  Wind,
  Droplets,
  Thermometer,
  Gauge,
  Timer,
  Stopwatch,
  Hourglass,
  Calendar as CalendarIcon,
  CalendarDays,
  CalendarCheck,
  CalendarX,
  CalendarPlus,
  CalendarMinus,
  CalendarRange,
  CalendarSearch,
  CalendarEdit,
  CalendarHeart,
  CalendarStar,
  CalendarClock,
  CalendarUser,
  CalendarSettings,
  CalendarDownload,
  CalendarUpload,
  CalendarShare,
  CalendarLock,
  CalendarUnlock,
  CalendarKey,
  CalendarWifi,
  CalendarWifiOff,
  CalendarSignal,
  CalendarBattery,
  CalendarPower,
  CalendarVolume,
  CalendarPlay,
  CalendarPause,
  CalendarStop,
  CalendarSkip,
  CalendarRepeat,
  CalendarShuffle,
  CalendarFast,
  CalendarRewind,
  CalendarMaximize,
  CalendarMinimize,
  CalendarMove,
  CalendarRotate,
  CalendarFlip,
  CalendarZoom,
  CalendarFocus,
  CalendarSun,
  CalendarMoon,
  CalendarCloud,
  CalendarRain,
  CalendarSnow,
  CalendarLightning,
  CalendarWind,
  CalendarDroplets,
  CalendarThermometer,
  CalendarGauge,
  CalendarTimer,
  CalendarStopwatch,
  CalendarHourglass,
  Send,
  Archive,
  Download,
  Upload,
  RefreshCw,
  Search,
  Filter,
  MoreHorizontal,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ExternalLink,
  Copy,
  Share,
  Share2,
  Link,
  Lock,
  Unlock,
  Key,
  Wifi,
  WifiOff,
  Signal,
  SignalZero,
  SignalOne,
  SignalTwo,
  SignalThree,
  Battery,
  BatteryLow,
  BatteryMedium,
  BatteryFull,
  Power,
  PowerOff,
  Volume2,
  VolumeX,
  Volume1,
  Mute,
  Unmute,
  PlayCircle,
  PauseCircle,
  StopCircle as StopCircleIcon,
  SkipBack as SkipBackIcon,
  SkipForward as SkipForwardIcon,
  Repeat as RepeatIcon,
  Shuffle as ShuffleIcon,
  FastForward as FastForwardIcon,
  Rewind as RewindIcon,
  Maximize as MaximizeIcon,
  Minimize as MinimizeIcon,
  Move as MoveIcon,
  RotateCw as RotateCwIcon,
  RotateCcw as RotateCcwIcon2,
  FlipHorizontal as FlipHorizontalIcon,
  FlipVertical as FlipVerticalIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  Focus as FocusIcon,
  Sun as SunIcon,
  Moon as MoonIcon,
  Cloud as CloudIcon,
  CloudRain as CloudRainIcon,
  CloudSnow as CloudSnowIcon,
  CloudLightning as CloudLightningIcon,
  Wind as WindIcon,
  Droplets as DropletsIcon,
  Thermometer as ThermometerIcon,
  Gauge as GaugeIcon,
  Timer as TimerIcon,
  Stopwatch as StopwatchIcon,
  Hourglass as HourglassIcon,
  Calendar as CalendarIcon2,
  CalendarDays as CalendarDaysIcon,
  CalendarCheck as CalendarCheckIcon,
  CalendarX as CalendarXIcon,
  CalendarPlus as CalendarPlusIcon,
  CalendarMinus as CalendarMinusIcon,
  CalendarRange as CalendarRangeIcon,
  CalendarSearch as CalendarSearchIcon,
  CalendarEdit as CalendarEditIcon,
  CalendarHeart as CalendarHeartIcon,
  CalendarStar as CalendarStarIcon,
  CalendarClock as CalendarClockIcon,
  CalendarUser as CalendarUserIcon,
  CalendarSettings as CalendarSettingsIcon,
  CalendarDownload as CalendarDownloadIcon,
  CalendarUpload as CalendarUploadIcon,
  CalendarShare as CalendarShareIcon,
  CalendarLock as CalendarLockIcon,
  CalendarUnlock as CalendarUnlockIcon,
  CalendarKey as CalendarKeyIcon,
  CalendarWifi as CalendarWifiIcon,
  CalendarWifiOff as CalendarWifiOffIcon,
  CalendarSignal as CalendarSignalIcon,
  CalendarBattery as CalendarBatteryIcon,
  CalendarPower as CalendarPowerIcon,
  CalendarVolume as CalendarVolumeIcon,
  CalendarPlay as CalendarPlayIcon,
  CalendarPause as CalendarPauseIcon,
  CalendarStop as CalendarStopIcon,
  CalendarSkip as CalendarSkipIcon,
  CalendarRepeat as CalendarRepeatIcon,
  CalendarShuffle as CalendarShuffleIcon,
  CalendarFast as CalendarFastIcon,
  CalendarRewind as CalendarRewindIcon,
  CalendarMaximize as CalendarMaximizeIcon,
  CalendarMinimize as CalendarMinimizeIcon,
  CalendarMove as CalendarMoveIcon,
  CalendarRotate as CalendarRotateIcon,
  CalendarFlip as CalendarFlipIcon,
  CalendarZoom as CalendarZoomIcon,
  CalendarFocus as CalendarFocusIcon,
  CalendarSun as CalendarSunIcon,
  CalendarMoon as CalendarMoonIcon,
  CalendarCloud as CalendarCloudIcon,
  CalendarRain as CalendarRainIcon,
  CalendarSnow as CalendarSnowIcon,
  CalendarLightning as CalendarLightningIcon,
  CalendarWind as CalendarWindIcon,
  CalendarDroplets as CalendarDropletsIcon,
  CalendarThermometer as CalendarThermometerIcon,
  CalendarGauge as CalendarGaugeIcon,
  CalendarTimer as CalendarTimerIcon,
  CalendarStopwatch as CalendarStopwatchIcon,
  CalendarHourglass as CalendarHourglassIcon,
  Brain,
  Cpu,
  Database,
  HardDrive,
  MemoryStick,
  MonitorSpeaker,
  Mouse,
  Keyboard,
  Headphones as HeadphonesIcon,
  Mic as MicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  X as XIcon,
  Check as CheckIcon,
  Plus as PlusIcon,
  Trash2 as Trash2Icon,
  Eye as EyeIcon,
  EyeOff as EyeOffIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  RotateCcw as RotateCcwIcon3,
  StopCircle as StopCircleIcon2,
  SkipBack as SkipBackIcon2,
  SkipForward as SkipForwardIcon2,
  Repeat as RepeatIcon2,
  Shuffle as ShuffleIcon2,
  FastForward as FastForwardIcon2,
  Rewind as RewindIcon2,
  Maximize as MaximizeIcon2,
  Minimize as MinimizeIcon2,
  Move as MoveIcon2,
  RotateCw as RotateCwIcon2,
  RotateCcw as RotateCcwIcon4,
  FlipHorizontal as FlipHorizontalIcon2,
  FlipVertical as FlipVerticalIcon2,
  ZoomIn as ZoomInIcon2,
  ZoomOut as ZoomOutIcon2,
  Focus as FocusIcon2,
  Sun as SunIcon2,
  Moon as MoonIcon2,
  Cloud as CloudIcon2,
  CloudRain as CloudRainIcon2,
  CloudSnow as CloudSnowIcon2,
  CloudLightning as CloudLightningIcon2,
  Wind as WindIcon2,
  Droplets as DropletsIcon2,
  Thermometer as ThermometerIcon2,
  Gauge as GaugeIcon2,
  Timer as TimerIcon2,
  Stopwatch as StopwatchIcon2,
  Hourglass as HourglassIcon2,
  Calendar as CalendarIcon3,
  CalendarDays as CalendarDaysIcon2,
  CalendarCheck as CalendarCheckIcon2,
  CalendarX as CalendarXIcon2,
  CalendarPlus as CalendarPlusIcon2,
  CalendarMinus as CalendarMinusIcon2,
  CalendarRange as CalendarRangeIcon2,
  CalendarSearch as CalendarSearchIcon2,
  CalendarEdit as CalendarEditIcon2,
  CalendarHeart as CalendarHeartIcon2,
  CalendarStar as CalendarStarIcon2,
  CalendarClock as CalendarClockIcon2,
  CalendarUser as CalendarUserIcon2,
  CalendarSettings as CalendarSettingsIcon2,
  CalendarDownload as CalendarDownloadIcon2,
  CalendarUpload as CalendarUploadIcon2,
  CalendarShare as CalendarShareIcon2,
  CalendarLock as CalendarLockIcon2,
  CalendarUnlock as CalendarUnlockIcon2,
  CalendarKey as CalendarKeyIcon2,
  CalendarWifi as CalendarWifiIcon2,
  CalendarWifiOff as CalendarWifiOffIcon2,
  CalendarSignal as CalendarSignalIcon2,
  CalendarBattery as CalendarBatteryIcon2,
  CalendarPower as CalendarPowerIcon2,
  CalendarVolume as CalendarVolumeIcon2,
  CalendarPlay as CalendarPlayIcon2,
  CalendarPause as CalendarPauseIcon2,
  CalendarStop as CalendarStopIcon2,
  CalendarSkip as CalendarSkipIcon2,
  CalendarRepeat as CalendarRepeatIcon2,
  CalendarShuffle as CalendarShuffleIcon2,
  CalendarFast as CalendarFastIcon2,
  CalendarRewind as CalendarRewindIcon2,
  CalendarMaximize as CalendarMaximizeIcon2,
  CalendarMinimize as CalendarMinimizeIcon2,
  CalendarMove as CalendarMoveIcon2,
  CalendarRotate as CalendarRotateIcon2,
  CalendarFlip as CalendarFlipIcon2,
  CalendarZoom as CalendarZoomIcon2,
  CalendarFocus as CalendarFocusIcon2,
  CalendarSun as CalendarSunIcon2,
  CalendarMoon as CalendarMoonIcon2,
  CalendarCloud as CalendarCloudIcon2,
  CalendarRain as CalendarRainIcon2,
  CalendarSnow as CalendarSnowIcon2,
  CalendarLightning as CalendarLightningIcon2,
  CalendarWind as CalendarWindIcon2,
  CalendarDroplets as CalendarDropletsIcon2,
  CalendarThermometer as CalendarThermometerIcon2,
  CalendarGauge as CalendarGaugeIcon2,
  CalendarTimer as CalendarTimerIcon2,
  CalendarStopwatch as CalendarStopwatchIcon2,
  CalendarHourglass as CalendarHourglassIcon2,
  TrendingUp,
  Activity,
  Target,
  Star,
  Award,
  Gift,
  Heart,
  ThumbsUp,
  ThumbsDown,
  MessageCircle,
  Send as SendIcon,
  Archive as ArchiveIcon,
  Download as DownloadIcon,
  Upload as UploadIcon,
  RefreshCw as RefreshCwIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  ChevronDown as ChevronDownIcon,
  ChevronUp as ChevronUpIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  ExternalLink as ExternalLinkIcon,
  Copy as CopyIcon,
  Share as ShareIcon,
  Share2 as Share2Icon,
  Link as LinkIcon,
  Lock as LockIcon,
  Unlock as UnlockIcon,
  Key as KeyIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  SignalZero as SignalZeroIcon,
  SignalOne as SignalOneIcon,
  SignalTwo as SignalTwoIcon,
  SignalThree as SignalThreeIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  BatteryMedium as BatteryMediumIcon,
  BatteryFull as BatteryFullIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Volume1 as Volume1Icon,
  Mute as MuteIcon,
  Unmute as UnmuteIcon,
  PlayCircle as PlayCircleIcon,
  PauseCircle as PauseCircleIcon,
  StopCircle as StopCircleIcon3,
  SkipBack as SkipBackIcon3,
  SkipForward as SkipForwardIcon3,
  Repeat as RepeatIcon3,
  Shuffle as ShuffleIcon3,
  FastForward as FastForwardIcon3,
  Rewind as RewindIcon3,
  Maximize as MaximizeIcon3,
  Minimize as MinimizeIcon3,
  Move as MoveIcon3,
  RotateCw as RotateCwIcon3,
  RotateCcw as RotateCcwIcon5,
  FlipHorizontal as FlipHorizontalIcon3,
  FlipVertical as FlipVerticalIcon3,
  ZoomIn as ZoomInIcon3,
  ZoomOut as ZoomOutIcon3,
  Focus as FocusIcon3,
  Sun as SunIcon3,
  Moon as MoonIcon3,
  Cloud as CloudIcon3,
  CloudRain as CloudRainIcon3,
  CloudSnow as CloudSnowIcon3,
  CloudLightning as CloudLightningIcon3,
  Wind as WindIcon3,
  Droplets as DropletsIcon3,
  Thermometer as ThermometerIcon3,
  Gauge as GaugeIcon3,
  Timer as TimerIcon3,
  Stopwatch as StopwatchIcon3,
  Hourglass as HourglassIcon3,
  Calendar as CalendarIcon4,
  CalendarDays as CalendarDaysIcon3,
  CalendarCheck as CalendarCheckIcon3,
  CalendarX as CalendarXIcon3,
  CalendarPlus as CalendarPlusIcon3,
  CalendarMinus as CalendarMinusIcon3,
  CalendarRange as CalendarRangeIcon3,
  CalendarSearch as CalendarSearchIcon3,
  CalendarEdit as CalendarEditIcon3,
  CalendarHeart as CalendarHeartIcon3,
  CalendarStar as CalendarStarIcon3,
  CalendarClock as CalendarClockIcon3,
  CalendarUser as CalendarUserIcon3,
  CalendarSettings as CalendarSettingsIcon3,
  CalendarDownload as CalendarDownloadIcon3,
  CalendarUpload as CalendarUploadIcon3,
  CalendarShare as CalendarShareIcon3,
  CalendarLock as CalendarLockIcon3,
  CalendarUnlock as CalendarUnlockIcon3,
  CalendarKey as CalendarKeyIcon3,
  CalendarWifi as CalendarWifiIcon3,
  CalendarWifiOff as CalendarWifiOffIcon3,
  CalendarSignal as CalendarSignalIcon3,
  CalendarBattery as CalendarBatteryIcon3,
  CalendarPower as CalendarPowerIcon3,
  CalendarVolume as CalendarVolumeIcon3,
  CalendarPlay as CalendarPlayIcon3,
  CalendarPause as CalendarPauseIcon3,
  CalendarStop as CalendarStopIcon3,
  CalendarSkip as CalendarSkipIcon3,
  CalendarRepeat as CalendarRepeatIcon3,
  CalendarShuffle as CalendarShuffleIcon3,
  CalendarFast as CalendarFastIcon3,
  CalendarRewind as CalendarRewindIcon3,
  CalendarMaximize as CalendarMaximizeIcon3,
  CalendarMinimize as CalendarMinimizeIcon3,
  CalendarMove as CalendarMoveIcon3,
  CalendarRotate as CalendarRotateIcon3,
  CalendarFlip as CalendarFlipIcon3,
  CalendarZoom as CalendarZoomIcon3,
  CalendarFocus as CalendarFocusIcon3,
  CalendarSun as CalendarSunIcon3,
  CalendarMoon as CalendarMoonIcon3,
  CalendarCloud as CalendarCloudIcon3,
  CalendarRain as CalendarRainIcon3,
  CalendarSnow as CalendarSnowIcon3,
  CalendarLightning as CalendarLightningIcon3,
  CalendarWind as CalendarWindIcon3,
  CalendarDroplets as CalendarDropletsIcon3,
  CalendarThermometer as CalendarThermometerIcon3,
  CalendarGauge as CalendarGaugeIcon3,
  CalendarTimer as CalendarTimerIcon3,
  CalendarStopwatch as CalendarStopwatchIcon3,
  CalendarHourglass as CalendarHourglassIcon3
} from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import { db, storage } from '../firebase';
import { doc, getDoc, setDoc, updateDoc, serverTimestamp, Timestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import BackButton from '../components/BackButton';
import TechnologyPageHeader from '../components/technology/TechnologyPageHeader';
import { useTechnologyEmbedded } from '../hooks/useTechnologyEmbedded';

const CHATBOT_COLLECTION = 'aiChatbotConfigs';
const DEFAULT_PROMPT = "You are a helpful and friendly chatbot for Prestige Building Company. Your role is to assist customers with inquiries about our construction services, answer questions about projects, help schedule consultations, and provide information about our expertise in residential and commercial building. Always be professional, courteous, and aim to provide accurate information. If you cannot answer a question, politely direct the customer to speak with one of our team members.";

const generateUniqueId = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

const createDefaultFunctions = () => ({
  endChat: { enabled: true },
  checkCalendarAvailability: { enabled: false, email: '' },
  bookCalendar: { enabled: false, email: '' },
  customFunctions: []
});

const createDefaultPersonality = () => ({
  name: "AI Assistant",
  type: "professional",
  tone: "friendly",
  formality: "moderate",
  warmth: "moderate",
  enthusiasm: "moderate",
  humor: false,
  empathy: true
});

const createDefaultKnowledgeBase = () => ({
  files: [],
  addWebsite: false
});

const createDefaultPostChatInfo = () => ([
  { id: 1, label: 'Client Name', type: 'Text', required: true },
  { id: 2, label: 'Interest', type: 'Text', required: false },
  { id: 3, label: 'Chat Summary', type: 'Text', required: true }
]);

const createDefaultChatHistory = () => {
  return [];
};

const createDefaultChatbotConfig = () => ({
  prompt: DEFAULT_PROMPT,
  functions: createDefaultFunctions(),
  personality: createDefaultPersonality(),
  knowledgeBase: createDefaultKnowledgeBase(),
  postChatInfo: createDefaultPostChatInfo(),
  chatHistory: createDefaultChatHistory(),
  status: 'off' // 'off', 'requested', 'on'
});

const normalizeKnowledgeBaseFiles = (files = []) => files.map((file) => ({
  ...file,
  uploadedAt: file?.uploadedAt?.toDate ? file.uploadedAt.toDate() : file?.uploadedAt ? new Date(file.uploadedAt) : null
}));

const normalizeChatHistory = (history = []) => history.map((chat) => ({
  ...chat,
  id: chat.id ?? generateUniqueId(),
  date: chat.date?.toDate ? chat.date.toDate() : (chat.date ? new Date(chat.date) : new Date()),
  postChatData: chat.postChatData ?? {},
  qualified: typeof chat.qualified === 'boolean' ? chat.qualified : false,
  transcript: chat.transcript ?? ''
}));

const serializeKnowledgeBaseFiles = (files = []) => files.map(({ file, uploadedAt, ...rest }) => ({
  ...rest,
  uploadedAt: uploadedAt instanceof Date
    ? Timestamp.fromDate(uploadedAt)
    : uploadedAt ?? Timestamp.fromDate(new Date())
}));

const serializeChatHistory = (history = []) => history.map((chat) => ({
  ...chat,
  date: Timestamp.fromDate(chat.date instanceof Date ? chat.date : new Date(chat.date || Date.now()))
}));

const buildFirestorePayload = (config) => ({
  prompt: config.prompt,
  functions: config.functions,
  personality: config.personality,
  knowledgeBase: {
    ...config.knowledgeBase,
    files: serializeKnowledgeBaseFiles(config.knowledgeBase?.files || [])
  },
  postChatInfo: config.postChatInfo,
  chatHistory: serializeChatHistory(config.chatHistory),
  status: config.status || 'off',
  updatedAt: serverTimestamp()
});

const Chatbot = ({ embedded: embeddedProp }) => {
  const { darkMode } = useTheme();
  const embedded = useTechnologyEmbedded(embeddedProp);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  // State for chatbot prompt
  const [prompt, setPrompt] = useState(DEFAULT_PROMPT);

  // State for functions
  const [functions, setFunctions] = useState(() => createDefaultFunctions());

  // State for personality
  const [personality, setPersonality] = useState(() => createDefaultPersonality());

  // State for knowledge base
  const [knowledgeBase, setKnowledgeBase] = useState(() => createDefaultKnowledgeBase());

  // State for post chat info rows
  const [postChatInfo, setPostChatInfo] = useState(() => createDefaultPostChatInfo());

  // State for chat history
  const [chatHistory, setChatHistory] = useState(() => createDefaultChatHistory());
  const [chatSearch, setChatSearch] = useState('');
  const [qualifiedFilter, setQualifiedFilter] = useState('all');
  const [selectedChat, setSelectedChat] = useState(null);
  const [showChatDetails, setShowChatDetails] = useState(false);

  // State for status
  const [status, setStatus] = useState('off');

  // State for loading and saving
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);
  const [hasLoadedConfig, setHasLoadedConfig] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [isUploadingKnowledge, setIsUploadingKnowledge] = useState(false);
  const [savedState, setSavedState] = useState(null);

  // State for popups
  const [showSettingsPopup, setShowSettingsPopup] = useState(false);
  const [showAnalyticsPopup, setShowAnalyticsPopup] = useState(false);
  const [showIntegrationPopup, setShowIntegrationPopup] = useState(false);
  const [showCustomizationPopup, setShowCustomizationPopup] = useState(false);
  const [showPostChatPopup, setShowPostChatPopup] = useState(false);

  // Firestore document reference for this user's chatbot config
  const chatbotDocRef = useMemo(() => {
    return currentUser ? doc(db, CHATBOT_COLLECTION, currentUser.uid) : null;
  }, [currentUser?.uid]);

  // Data is loaded from and saved to Firestore per user
  useEffect(() => {
    let isMounted = true;

    const loadConfig = async () => {
      if (!chatbotDocRef) {
        if (isMounted) {
          setIsLoadingConfig(false);
          setHasLoadedConfig(false);
        }
        return;
      }

      setIsLoadingConfig(true);
      setLoadError(null);

      try {
        const snapshot = await getDoc(chatbotDocRef);
        if (!isMounted) return;

        if (snapshot.exists()) {
          const data = snapshot.data();
          setPrompt(data.prompt ?? DEFAULT_PROMPT);

          const mergedFunctions = createDefaultFunctions();
          if (data.functions) {
            if (data.functions.endChat) {
              mergedFunctions.endChat = { ...mergedFunctions.endChat, ...data.functions.endChat };
            }
            if (data.functions.checkCalendarAvailability) {
              mergedFunctions.checkCalendarAvailability = { ...mergedFunctions.checkCalendarAvailability, ...data.functions.checkCalendarAvailability };
            }
            if (data.functions.bookCalendar) {
              mergedFunctions.bookCalendar = { ...mergedFunctions.bookCalendar, ...data.functions.bookCalendar };
            }
            if (Array.isArray(data.functions.customFunctions)) {
              mergedFunctions.customFunctions = data.functions.customFunctions;
            }
          }
          setFunctions(mergedFunctions);

          setPersonality({
            ...createDefaultPersonality(),
            ...(data.personality || {})
          });

          setKnowledgeBase({
            files: normalizeKnowledgeBaseFiles(data.knowledgeBase?.files || []),
            addWebsite: Boolean(data.knowledgeBase?.addWebsite)
          });

          setPostChatInfo(
            Array.isArray(data.postChatInfo) && data.postChatInfo.length
              ? data.postChatInfo
              : createDefaultPostChatInfo()
          );

          const history = Array.isArray(data.chatHistory) && data.chatHistory.length
            ? normalizeChatHistory(data.chatHistory)
            : createDefaultChatHistory();
          setChatHistory(history);

          // Load status
          setStatus(data.status || 'off');

          // Store saved state for change detection
          const currentState = {
            prompt: data.prompt ?? DEFAULT_PROMPT,
            functions: mergedFunctions,
            personality: { ...createDefaultPersonality(), ...(data.personality || {}) },
            knowledgeBase: {
              files: normalizeKnowledgeBaseFiles(data.knowledgeBase?.files || []),
              addWebsite: Boolean(data.knowledgeBase?.addWebsite)
            },
            postChatInfo: Array.isArray(data.postChatInfo) && data.postChatInfo.length
              ? data.postChatInfo
              : createDefaultPostChatInfo(),
            chatHistory: history,
            status: data.status || 'off'
          };
          setSavedState(currentState);
        } else {
          const defaults = createDefaultChatbotConfig();
          await setDoc(chatbotDocRef, {
            ...buildFirestorePayload(defaults),
            createdAt: serverTimestamp()
          });
          if (!isMounted) return;
          setPrompt(defaults.prompt);
          setFunctions(defaults.functions);
          setPersonality(defaults.personality);
          setKnowledgeBase(defaults.knowledgeBase);
          setPostChatInfo(defaults.postChatInfo);
          setChatHistory(defaults.chatHistory);
          setStatus(defaults.status);
          setSavedState(defaults);
        }

        setHasLoadedConfig(true);
        setSaveError(null);
      } catch (error) {
        console.error('Error loading chatbot configuration', error);
        if (isMounted) {
          setLoadError('Unable to load your chatbot settings. Please try again.');
        }
      } finally {
        if (isMounted) {
          setIsLoadingConfig(false);
        }
      }
    };

    loadConfig();

    return () => {
      isMounted = false;
    };
  }, [chatbotDocRef]);

  const saveChanges = useCallback(async () => {
    if (!chatbotDocRef || !hasLoadedConfig) {
      return;
    }

    setIsSaving(true);
    setSaveError(null);

    try {
      const payload = buildFirestorePayload({
        prompt,
        functions,
        personality,
        knowledgeBase,
        postChatInfo,
        chatHistory,
        status
      });
      await setDoc(chatbotDocRef, payload, { merge: true });
      
      // Update saved state after successful save
      setSavedState({
        prompt,
        functions,
        personality,
        knowledgeBase,
        postChatInfo,
        chatHistory,
        status
      });
      setHasUnsavedChanges(false);
    } catch (error) {
      console.error('Error saving chatbot configuration', error);
      setSaveError('Failed to save changes. Please try again.');
    } finally {
      setIsSaving(false);
    }
  }, [chatbotDocRef, hasLoadedConfig, prompt, functions, personality, knowledgeBase, postChatInfo, chatHistory, status]);

  // Detect unsaved changes
  useEffect(() => {
    if (!hasLoadedConfig || isLoadingConfig || !savedState) {
      setHasUnsavedChanges(false);
      return;
    }

    const currentState = {
      prompt,
      functions,
      personality,
      knowledgeBase,
      postChatInfo,
      chatHistory,
      status
    };

    // Deep comparison (simplified - for production, use a proper deep equality check)
    const hasChanges = JSON.stringify(currentState) !== JSON.stringify(savedState);
    setHasUnsavedChanges(hasChanges);
  }, [prompt, functions, personality, knowledgeBase, postChatInfo, chatHistory, status, hasLoadedConfig, isLoadingConfig, savedState]);

  // Handle chatbot request
  const handleRequestChatbot = async () => {
    if (!currentUser) {
      alert('Please sign in to request chatbot service.');
      return;
    }

    try {
      // Get user data to get company name
      const userRef = doc(db, 'users', currentUser.uid);
      const userDoc = await getDoc(userRef);
      const userData = userDoc.exists() ? userDoc.data() : {};
      
      const companyName = userData.company || userData.displayName || 'Unknown Company';
      const requestedByName = userData.displayName || 
                             (userData.firstName && userData.lastName ? `${userData.firstName} ${userData.lastName}` : '') ||
                             userData.email || 
                             'Unknown User';

      // Create chatbot request
      const requestId = generateUniqueId();
      const chatbotRequest = {
        id: requestId,
        name: 'AI Chatbot',
        description: 'AI Chatbot service request',
        status: 'requested',
        requestedBy: requestedByName,
        company: companyName,
        userId: currentUser.uid,
        createdAt: new Date().toISOString(),
        lastUpdated: new Date().toISOString()
      };

      // Add to user document's chatbotRequests array
      const existingRequests = userData.chatbotRequests || [];
      await updateDoc(userRef, {
        chatbotRequests: [...existingRequests, chatbotRequest]
      });

      // Update status to 'requested' and save
      const newStatus = 'requested';
      setStatus(newStatus);
      
      // Save the status change directly
      if (chatbotDocRef) {
        await setDoc(chatbotDocRef, {
          status: newStatus,
          updatedAt: serverTimestamp()
        }, { merge: true });
        
        // Update saved state
        setSavedState(prev => prev ? { ...prev, status: newStatus } : null);
        setHasUnsavedChanges(false);
      }
    } catch (error) {
      console.error('Error requesting chatbot service:', error);
      alert('Failed to request chatbot service. Please try again.');
    }
  };

  // Handle cancel chatbot request
  const handleCancelRequest = async () => {
    if (!currentUser) {
      alert('Please sign in to cancel chatbot service request.');
      return;
    }

    try {
      // Get user data
      const userRef = doc(db, 'users', currentUser.uid);
      const userDoc = await getDoc(userRef);
      const userData = userDoc.exists() ? userDoc.data() : {};
      
      // Remove chatbot request from user document
      const existingRequests = userData.chatbotRequests || [];
      const updatedRequests = existingRequests.filter(req => req.status !== 'requested');
      
      await updateDoc(userRef, {
        chatbotRequests: updatedRequests,
        lastUpdated: new Date().toISOString()
      });

      // Update status to 'off' and save
      const newStatus = 'off';
      setStatus(newStatus);
      
      // Save the status change directly
      if (chatbotDocRef) {
        await setDoc(chatbotDocRef, {
          status: newStatus,
          updatedAt: serverTimestamp()
        }, { merge: true });
        
        // Update saved state
        setSavedState(prev => prev ? { ...prev, status: newStatus } : null);
        setHasUnsavedChanges(false);
      }
    } catch (error) {
      console.error('Error canceling chatbot service request:', error);
      alert('Failed to cancel chatbot service request. Please try again.');
    }
  };

  const handleFunctionToggle = (functionName) => {
    setFunctions(prev => ({
      ...prev,
      [functionName]: {
        ...prev[functionName],
        enabled: !prev[functionName].enabled
      }
    }));
  };

  const handleFunctionConfig = (functionName, field, value) => {
    setFunctions(prev => ({
      ...prev,
      [functionName]: {
        ...prev[functionName],
        [field]: value
      }
    }));
  };

  const addCustomFunction = (description) => {
    setFunctions(prev => ({
      ...prev,
      customFunctions: [...prev.customFunctions, { id: generateUniqueId(), description, enabled: true }]
    }));
  };

  const removeCustomFunction = (id) => {
    setFunctions(prev => ({
      ...prev,
      customFunctions: prev.customFunctions.filter(f => f.id !== id)
    }));
  };

  const toggleCustomFunction = (id) => {
    setFunctions(prev => ({
      ...prev,
      customFunctions: prev.customFunctions.map(f => 
        f.id === id ? { ...f, enabled: !f.enabled } : f
      )
    }));
  };

  const handlePersonalityChange = (field, value) => {
    setPersonality(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleFileUpload = async (e) => {
    if (!currentUser) {
      alert('Please sign in to upload files.');
      return;
    }

    const files = Array.from(e.target.files || []);
    const pdfFiles = files.filter(file => file.type === 'application/pdf');

    if (knowledgeBase.files.length + pdfFiles.length > 5) {
      alert('Maximum 5 PDFs allowed');
      if (e.target) e.target.value = '';
      return;
    }

    if (!pdfFiles.length) {
      if (e.target) e.target.value = '';
      return;
    }

    setIsUploadingKnowledge(true);

    try {
      const uploadedFiles = [];

      for (const file of pdfFiles) {
        const id = generateUniqueId();
        const storagePath = `aiChatbot/${currentUser.uid}/${id}-${file.name}`;
        const fileRef = ref(storage, storagePath);
        await uploadBytes(fileRef, file);
        const url = await getDownloadURL(fileRef);
        uploadedFiles.push({
          id,
          name: file.name,
          size: file.size,
          storagePath,
          url,
          uploadedAt: new Date()
        });
      }

      setKnowledgeBase(prev => ({
        ...prev,
        files: [...prev.files, ...uploadedFiles]
      }));
    } catch (error) {
      console.error('Error uploading knowledge base files', error);
      alert('Failed to upload one or more files. Please try again.');
    } finally {
      setIsUploadingKnowledge(false);
      if (e.target) e.target.value = '';
    }
  };

  const removeFile = async (id) => {
    const fileToRemove = knowledgeBase.files.find(f => f.id === id);
    if (!fileToRemove) return;

    if (fileToRemove.storagePath) {
      try {
        await deleteObject(ref(storage, fileToRemove.storagePath));
      } catch (error) {
        console.error('Error removing knowledge base file from storage', error);
      }
    }

    setKnowledgeBase(prev => ({
      ...prev,
      files: prev.files.filter(f => f.id !== id)
    }));
  };

  const handleWebsiteToggle = (enabled) => {
    setKnowledgeBase(prev => ({
      ...prev,
      addWebsite: enabled
    }));
  };

  const addPostChatInfoRow = () => {
    setPostChatInfo(prev => [...prev, {
      id: generateUniqueId(),
      label: '',
      type: 'Text',
      required: false
    }]);
  };

  const handleChatRowClick = (chat) => {
    setSelectedChat(chat);
    setShowChatDetails(true);
  };

  const handleDeleteChat = (chatId) => {
    setChatHistory(prev => prev.filter((chat) => chat.id !== chatId));
    setShowChatDetails(false);
    setSelectedChat(null);
  };

  const handleCloseChatDetails = () => {
    setShowChatDetails(false);
    setSelectedChat(null);
  };

  const filteredChatHistory = chatHistory.filter((chat) => {
    const normalizedSearch = chatSearch.toLowerCase().trim();
    const searchTarget = `${chat.clientName || ''} ${chat.email || ''}`.toLowerCase();
    const searchMatch = searchTarget.includes(normalizedSearch);
    const qualifiedMatch = qualifiedFilter === 'all'
      ? true
      : qualifiedFilter === 'qualified'
        ? chat.qualified
        : !chat.qualified;

    return searchMatch && qualifiedMatch;
  });

  const updatePostChatInfoRow = (id, field, value) => {
    setPostChatInfo(prev => prev.map(row => 
      row.id === id ? { ...row, [field]: value } : row
    ));
  };

  const removePostChatInfoRow = (id) => {
    setPostChatInfo(prev => prev.filter(row => row.id !== id));
  };

  const handlePromptChange = (value) => {
    setPrompt(value);
  };

  // Custom Function Form Component
  const CustomFunctionForm = ({ darkMode, onAdd }) => {
    const [description, setDescription] = useState('');

    const handleSubmit = (e) => {
      e.preventDefault();
      if (description.trim()) {
        onAdd(description.trim());
        setDescription('');
      }
    };

    return (
      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
            Describe the custom function
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className={`w-full px-3 py-2 border rounded-md text-sm ${
              darkMode 
                ? 'bg-gray-600 border-gray-500 text-white' 
                : 'bg-white border-gray-300 text-gray-900'
            }`}
            rows={3}
            placeholder="Describe what this custom function should do..."
          />
        </div>
        <button
          type="submit"
          className={`px-4 py-2 rounded-md text-sm ${darkMode ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}
        >
          Add Custom Function
        </button>
      </form>
    );
  };

  // Get status badge styling
  const getStatusBadge = () => {
    const statusConfig = {
      'off': { bg: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300', text: 'Off' },
      'requested': { bg: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300', text: 'Requested' },
      'on': { bg: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300', text: 'On' }
    };
    const config = statusConfig[status] || statusConfig['off'];
    return (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${config.bg}`}>
        {config.text}
      </span>
    );
  };

  if (isLoadingConfig) {
    return (
      <div className={embedded ? '' : 'p-6'}>
        {!embedded && <TechnologyPageHeader title="AI Chatbot" />}
        <div className="flex items-center justify-center py-24">
          <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Loading your chatbot...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={embedded ? '' : 'relative min-h-screen p-6'}>
      {!embedded && <PortalBackground />}
      <div className={embedded ? '' : 'relative'}>
      {!embedded && <TechnologyPageHeader title="AI Chatbot" />}
      <div className="flex justify-center mb-8">
        {getStatusBadge()}
      </div>

      {loadError && (
        <div className={`mb-6 rounded-lg border ${darkMode ? 'border-red-400 bg-red-500/10 text-red-200' : 'border-red-200 bg-red-50 text-red-700'}`}>
          <p className="px-4 py-3 text-sm">{loadError}</p>
        </div>
      )}

      {saveError && (
        <div className={`mb-6 rounded-lg border ${darkMode ? 'border-red-400 bg-red-500/10 text-red-200' : 'border-red-200 bg-red-50 text-red-700'}`}>
          <p className="px-4 py-3 text-sm">{saveError}</p>
        </div>
      )}

      {/* Quick Action Cards */}
      <div className="grid grid-cols-5 gap-4 mb-8">
        <div 
          onClick={() => setShowSettingsPopup(true)}
          className={`${darkMode ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600'} rounded-lg shadow-md p-4 cursor-pointer transition-colors`}
        >
          <div className="flex flex-col items-center text-center">
            <FileText size={24} className="text-white mb-2" />
            <span className="text-white font-medium text-sm">Prompt</span>
          </div>
        </div>
        
        <div 
          onClick={() => setShowAnalyticsPopup(true)}
          className={`${darkMode ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600'} rounded-lg shadow-md p-4 cursor-pointer transition-colors`}
        >
          <div className="flex flex-col items-center text-center">
            <Zap size={24} className="text-white mb-2" />
            <span className="text-white font-medium text-sm">Functions</span>
          </div>
        </div>
        
        <div 
          onClick={() => setShowIntegrationPopup(true)}
          className={`${darkMode ? 'bg-purple-600 hover:bg-purple-700' : 'bg-purple-500 hover:bg-purple-600'} rounded-lg shadow-md p-4 cursor-pointer transition-colors`}
        >
          <div className="flex flex-col items-center text-center">
            <User size={24} className="text-white mb-2" />
            <span className="text-white font-medium text-sm">Personality</span>
          </div>
        </div>
        
        <div 
          onClick={() => setShowCustomizationPopup(true)}
          className={`${darkMode ? 'bg-orange-600 hover:bg-orange-700' : 'bg-orange-500 hover:bg-orange-600'} rounded-lg shadow-md p-4 cursor-pointer transition-colors`}
        >
          <div className="flex flex-col items-center text-center">
            <Brain size={24} className="text-white mb-2" />
            <span className="text-white font-medium text-sm">Knowledge Base</span>
          </div>
        </div>
        
        <div 
          onClick={() => setShowPostChatPopup(true)}
          className={`${darkMode ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-indigo-500 hover:bg-indigo-600'} rounded-lg shadow-md p-4 cursor-pointer transition-colors`}
        >
          <div className="flex flex-col items-center text-center">
            <FileText size={24} className="text-white mb-2" />
            <span className="text-white font-medium text-sm">Post Chat</span>
          </div>
        </div>
      </div>

      {/* Chat History or Request/Cancel Button */}
      {status === 'off' ? (
        <div className={`rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm p-12 mb-8`}>
          <div className="text-center">
            <MessageSquare size={48} className={`mx-auto mb-4 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} />
            <h2 className={`text-2xl font-semibold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              AI Chatbot Service
            </h2>
            <p className={`text-lg mb-8 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Request access to the AI Chatbot service to start managing your chats
            </p>
            <button
              onClick={handleRequestChatbot}
              className={`w-full max-w-md mx-auto px-8 py-4 rounded-lg font-semibold text-lg transition-all ${
                darkMode
                  ? 'bg-blue-600 hover:bg-blue-700 text-white'
                  : 'bg-blue-500 hover:bg-blue-600 text-white'
              }`}
            >
              Request AI Chatbot Service
            </button>
          </div>
        </div>
      ) : status === 'requested' ? (
        <div className={`rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm p-12 mb-8`}>
          <div className="text-center">
            <MessageSquare size={48} className={`mx-auto mb-4 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} />
            <h2 className={`text-2xl font-semibold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              AI Chatbot Service Requested
            </h2>
            <p className={`text-lg mb-8 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Your request is pending approval. You can cancel your request at any time.
            </p>
            <button
              onClick={handleCancelRequest}
              className={`w-full max-w-md mx-auto px-8 py-4 rounded-lg font-semibold text-lg transition-all ${
                darkMode
                  ? 'bg-yellow-600 hover:bg-yellow-700 text-white'
                  : 'bg-yellow-500 hover:bg-yellow-600 text-white'
              }`}
            >
              Cancel Request
            </button>
          </div>
        </div>
      ) : status === 'on' ? (
        <div className={`rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm p-6 border ${darkMode ? 'border-gray-700' : 'border-gray-200'} mb-8`}>
          <div className="flex items-center justify-center gap-2 mb-6">
            <MessageSquare size={24} className="text-blue-500" />
            <h2 className={`text-xl font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Chat History</h2>
          </div>

          <div className="flex flex-col md:flex-row gap-4 mb-6">
            <div className="relative flex-1">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                value={chatSearch}
                onChange={(e) => setChatSearch(e.target.value)}
                placeholder="Search by client name..."
                className={`w-full pl-9 pr-3 py-2 rounded-md border text-sm ${
                  darkMode
                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                    : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                }`}
              />
            </div>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-2">
              <label className={`text-sm font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Qualified Filter
              </label>
              <select
                value={qualifiedFilter}
                onChange={(e) => setQualifiedFilter(e.target.value)}
                className={`px-3 py-2 rounded-md border text-sm ${
                  darkMode
                    ? 'bg-gray-700 border-gray-600 text-white'
                    : 'bg-white border-gray-300 text-gray-900'
                }`}
              >
                <option value="all">All</option>
                <option value="qualified">Qualified Only</option>
                <option value="unqualified">Not Qualified</option>
              </select>
            </div>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className={`border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                  <th className={`text-left py-3 px-4 font-semibold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Date</th>
                  <th className={`text-left py-3 px-4 font-semibold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name</th>
                  <th className={`text-left py-3 px-4 font-semibold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Duration</th>
                  <th className={`text-left py-3 px-4 font-semibold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Qualified?</th>
                </tr>
              </thead>
              <tbody>
                {filteredChatHistory.length > 0 ? (
                  filteredChatHistory.map((chat) => (
                    <tr 
                      key={chat.id} 
                      onClick={() => handleChatRowClick(chat)}
                      className={`border-b cursor-pointer ${
                        darkMode 
                          ? 'border-gray-700 hover:bg-gray-700/80' 
                          : 'border-gray-200 hover:bg-gray-100'
                      }`}
                    >
                      <td className={`py-3 px-4 ${darkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                        {new Date(chat.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </td>
                      <td className={`py-3 px-4 ${darkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                        {chat.clientName || 'Unknown'}
                      </td>
                      <td className={`py-3 px-4 ${darkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                        {chat.duration || 'N/A'}
                      </td>
                      <td className={`py-3 px-4 ${darkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                        {chat.qualified ? (
                          <span className="inline-flex items-center gap-1">
                            <CheckCircle size={16} className="text-green-500" />
                            <span className="text-green-500">Yes</span>
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1">
                            <XCircle size={16} className="text-red-500" />
                            <span className="text-red-500">No</span>
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={4}
                      className={`py-6 px-4 text-center text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}
                    >
                      No chats match your search/filter criteria.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}

      {/* Chat Details Popup */}
      {showChatDetails && selectedChat && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className={`${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'} rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto`}>
            <div className="p-6 space-y-6">
              <div className="flex justify-between items-center gap-4">
                <div className="flex-1 text-center">
                  <p className="text-sm uppercase tracking-wide text-gray-400">Chat Details</p>
                  <h3 className="text-2xl font-bold mt-1">{selectedChat.clientName || 'Unknown'}</h3>
                  <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    {selectedChat.date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                  </p>
                </div>
                <button
                  onClick={handleCloseChatDetails}
                  className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                >
                  <X size={20} className={darkMode ? 'text-gray-300' : 'text-gray-600'} />
                </button>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4 text-center`}>
                  <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">Email</p>
                  <p className="text-lg font-semibold">{selectedChat.email || 'N/A'}</p>
                </div>
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4 text-center`}>
                  <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">Duration</p>
                  <p className="text-lg font-semibold">{selectedChat.duration || 'N/A'}</p>
                </div>
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4 text-center`}>
                  <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">Qualified</p>
                  <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${
                    selectedChat.qualified
                      ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300'
                      : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300'
                  }`}>
                    {selectedChat.qualified ? 'Yes' : 'No'}
                  </span>
                </div>
              </div>

              <div>
                <h4 className="text-lg font-semibold mb-3 text-center">Post Chat Information</h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {postChatInfo.map((field) => {
                    const value = selectedChat.postChatData?.[field.label] ?? 'Not provided';
                    const isChatSummary = field.label === 'Chat Summary';
                    return (
                      <div
                        key={field.id}
                        className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4 ${isChatSummary ? 'sm:col-span-2' : ''}`}
                      >
                        <p className={`text-sm font-medium mb-1 text-center ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                          {field.label}
                          {field.required && <span className="text-red-500 ml-1">*</span>}
                        </p>
                        <p className={`text-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>{value}</p>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div>
                <h4 className="text-lg font-semibold mb-3 text-center">Chat Transcript</h4>
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <p className={`text-sm leading-relaxed text-center ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
                    {selectedChat.transcript || 'No transcript available.'}
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-4 border-t border-gray-700/40">
                <button
                  onClick={() => handleDeleteChat(selectedChat.id)}
                  className="flex items-center gap-2 px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white text-sm"
                >
                  <Trash2 size={16} />
                  Delete Chat
                </button>
                <button
                  onClick={handleCloseChatDetails}
                  className={`px-4 py-2 rounded-md text-sm ${
                    darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
                  }`}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Prompt Popup */}
      {showSettingsPopup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className={`bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 max-w-4xl w-full max-h-[90vh] overflow-y-auto mx-auto`}>
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <div className="w-10"></div>
                <h2 className={`text-2xl font-bold tracking-tight text-gray-900 dark:text-white`}>Prompt</h2>
                <button 
                  onClick={() => setShowSettingsPopup(false)}
                  className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                >
                  <X size={24} className={darkMode ? 'text-gray-300' : 'text-gray-600'} />
                </button>
              </div>

              <div className="space-y-6">
                {/* Informative Message */}
                <div className={`bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 rounded-xl border p-4`}>
                  <div className="flex items-start gap-3">
                    <AlertCircle size={20} className={`${darkMode ? 'text-blue-400' : 'text-blue-600'} mt-0.5 flex-shrink-0`} />
                    <div>
                      <h3 className={`font-semibold mb-1 ${darkMode ? 'text-blue-300' : 'text-blue-900'}`}>
                        Instructions for Your Chatbot
                      </h3>
                      <p className={`text-sm ${darkMode ? 'text-blue-200' : 'text-blue-800'}`}>
                        The prompt below defines the instructions and personality for your chatbot. This is how your chatbot will behave, what it will know, and how it will interact with customers. Write clear, specific instructions about your business, services, and the chatbot's role.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Prompt Input */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <h3 className={`font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Chatbot Prompt</h3>
                  <textarea
                    value={prompt}
                    onChange={(e) => handlePromptChange(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-md text-sm font-mono ${
                      darkMode 
                        ? 'bg-gray-600 border-gray-500 text-white' 
                        : 'bg-white border-gray-300 text-gray-900'
                    }`}
                    rows={12}
                    placeholder="Enter your chatbot instructions..."
                  />
                </div>
              </div>

              <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-700/40">
                {hasUnsavedChanges && (
                  <button
                    onClick={saveChanges}
                    disabled={isSaving}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                      isSaving
                        ? 'bg-gray-400 cursor-not-allowed text-white'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                    }`}
                  >
                    {isSaving ? (
                      <>
                        <RefreshCw size={16} className="animate-spin" />
                        <span>Saving...</span>
                      </>
                    ) : (
                      <>
                        <Check size={16} />
                        <span>Save Changes</span>
                      </>
                    )}
                  </button>
                )}
                <div className="ml-auto">
                  <button 
                    onClick={() => setShowSettingsPopup(false)}
                    className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Functions Popup */}
      {showAnalyticsPopup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className={`bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 max-w-4xl w-full max-h-[90vh] overflow-y-auto mx-auto`}>
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <div className="w-10"></div>
                <h2 className={`text-2xl font-bold tracking-tight text-gray-900 dark:text-white`}>Functions</h2>
                <button 
                  onClick={() => setShowAnalyticsPopup(false)}
                  className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                >
                  <X size={24} className={darkMode ? 'text-gray-300' : 'text-gray-600'} />
                </button>
              </div>

              <div className="space-y-6">
                {/* End Chat/Call */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <XCircle size={24} className="text-red-500" />
                      <div>
                        <h3 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>End Chat</h3>
                        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Allow the chatbot to end conversations</p>
                      </div>
                    </div>
                    <button
                      onClick={() => handleFunctionToggle('endChat')}
                      className={`w-12 h-6 rounded-full transition-colors ${
                        functions.endChat.enabled 
                          ? 'bg-green-500' 
                          : 'bg-gray-300 dark:bg-gray-600'
                      }`}
                    >
                      <div className={`w-5 h-5 bg-white rounded-full transition-transform ${
                        functions.endChat.enabled ? 'translate-x-6' : 'translate-x-0.5'
                      }`} />
                    </button>
                  </div>
                </div>

                {/* Check Calendar Availability */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <Calendar size={24} className="text-blue-500" />
                      <div>
                        <h3 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Check Calendar Availability</h3>
                        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Check available time slots in the calendar</p>
                      </div>
                    </div>
                    <button
                      onClick={() => handleFunctionToggle('checkCalendarAvailability')}
                      className={`w-12 h-6 rounded-full transition-colors ${
                        functions.checkCalendarAvailability.enabled 
                          ? 'bg-green-500' 
                          : 'bg-gray-300 dark:bg-gray-600'
                      }`}
                    >
                      <div className={`w-5 h-5 bg-white rounded-full transition-transform ${
                        functions.checkCalendarAvailability.enabled ? 'translate-x-6' : 'translate-x-0.5'
                      }`} />
                    </button>
                  </div>
                  {functions.checkCalendarAvailability.enabled && (
                    <div>
                      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        Calendar Email
                      </label>
                      <input
                        type="email"
                        value={functions.checkCalendarAvailability.email || ''}
                        onChange={(e) => handleFunctionConfig('checkCalendarAvailability', 'email', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-md text-sm ${
                          darkMode 
                            ? 'bg-gray-600 border-gray-500 text-white' 
                            : 'bg-white border-gray-300 text-gray-900'
                        }`}
                        placeholder="calendar@example.com"
                      />
                    </div>
                  )}
                </div>

                {/* Book Calendar */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <CalendarCheck size={24} className="text-green-500" />
                      <div>
                        <h3 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Book on Calendar</h3>
                        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Book appointments on the calendar</p>
                      </div>
                    </div>
                    <button
                      onClick={() => handleFunctionToggle('bookCalendar')}
                      className={`w-12 h-6 rounded-full transition-colors ${
                        functions.bookCalendar.enabled 
                          ? 'bg-green-500' 
                          : 'bg-gray-300 dark:bg-gray-600'
                      }`}
                    >
                      <div className={`w-5 h-5 bg-white rounded-full transition-transform ${
                        functions.bookCalendar.enabled ? 'translate-x-6' : 'translate-x-0.5'
                      }`} />
                    </button>
                  </div>
                  {functions.bookCalendar.enabled && (
                    <div>
                      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        Calendar Email
                      </label>
                      <input
                        type="email"
                        value={functions.bookCalendar.email}
                        onChange={(e) => handleFunctionConfig('bookCalendar', 'email', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-md text-sm ${
                          darkMode 
                            ? 'bg-gray-600 border-gray-500 text-white' 
                            : 'bg-white border-gray-300 text-gray-900'
                        }`}
                        placeholder="calendar@example.com"
                      />
                    </div>
                  )}
                </div>

                {/* Custom Functions */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <h3 className={`font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Custom Functions</h3>
                  
                  {/* Add Custom Function */}
                  <CustomFunctionForm 
                    darkMode={darkMode} 
                    onAdd={addCustomFunction}
                  />

                  {/* List of Custom Functions */}
                  <div className="space-y-3 mt-4">
                    {functions.customFunctions.map((customFunc) => (
                      <div key={customFunc.id} className={`${darkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} rounded border p-3`}>
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <p className={`text-sm ${darkMode ? 'text-white' : 'text-gray-900'}`}>{customFunc.description}</p>
                            <span className={`text-xs ${customFunc.enabled ? 'text-green-500' : 'text-gray-500'}`}>
                              {customFunc.enabled ? 'Enabled' : 'Disabled'}
                            </span>
                          </div>
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => toggleCustomFunction(customFunc.id)}
                              className={`w-10 h-5 rounded-full transition-colors ${
                                customFunc.enabled 
                                  ? 'bg-green-500' 
                                  : 'bg-gray-300 dark:bg-gray-600'
                              }`}
                            >
                              <div className={`w-4 h-4 bg-white rounded-full transition-transform ${
                                customFunc.enabled ? 'translate-x-5' : 'translate-x-0.5'
                              }`} />
                            </button>
                            <button
                              onClick={() => removeCustomFunction(customFunc.id)}
                              className="p-1 text-red-500 hover:bg-red-100 dark:hover:bg-red-900 rounded"
                            >
                              <Trash2 size={16} />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-700/40">
                {hasUnsavedChanges && (
                  <button
                    onClick={saveChanges}
                    disabled={isSaving}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                      isSaving
                        ? 'bg-gray-400 cursor-not-allowed text-white'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                    }`}
                  >
                    {isSaving ? (
                      <>
                        <RefreshCw size={16} className="animate-spin" />
                        <span>Saving...</span>
                      </>
                    ) : (
                      <>
                        <Check size={16} />
                        <span>Save Changes</span>
                      </>
                    )}
                  </button>
                )}
                <div className="ml-auto">
                  <button 
                    onClick={() => setShowAnalyticsPopup(false)}
                    className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Personality Popup */}
      {showIntegrationPopup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className={`bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 max-w-4xl w-full max-h-[90vh] overflow-y-auto mx-auto`}>
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <div className="w-10"></div>
                <h2 className={`text-2xl font-bold tracking-tight text-gray-900 dark:text-white`}>Personality</h2>
                <button 
                  onClick={() => setShowIntegrationPopup(false)}
                  className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                >
                  <X size={24} className={darkMode ? 'text-gray-300' : 'text-gray-600'} />
                </button>
              </div>

              <div className="space-y-6">
                {/* Name/Title */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <h3 className={`font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Name/Title</h3>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                      Chatbot Name
                    </label>
                    <input
                      type="text"
                      value={personality.name}
                      onChange={(e) => handlePersonalityChange('name', e.target.value)}
                      className={`w-full px-3 py-2 border rounded-md text-sm ${
                        darkMode 
                          ? 'bg-gray-600 border-gray-500 text-white' 
                          : 'bg-white border-gray-300 text-gray-900'
                      }`}
                      placeholder="Enter chatbot name"
                    />
                  </div>
                </div>

                {/* Personality Type */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <h3 className={`font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Personality Type</h3>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                      Select Personality Type
                    </label>
                    <select
                      value={personality.type}
                      onChange={(e) => handlePersonalityChange('type', e.target.value)}
                      className={`w-full px-3 py-2 border rounded-md text-sm ${
                        darkMode 
                          ? 'bg-gray-600 border-gray-500 text-white' 
                          : 'bg-white border-gray-300 text-gray-900'
                      }`}
                    >
                      <option value="professional">Professional</option>
                      <option value="friendly">Friendly</option>
                      <option value="casual">Casual</option>
                      <option value="formal">Formal</option>
                      <option value="enthusiastic">Enthusiastic</option>
                      <option value="calm">Calm</option>
                      <option value="humorous">Humorous</option>
                      <option value="empathetic">Empathetic</option>
                    </select>
                  </div>
                </div>

                {/* Personality Customization */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <h3 className={`font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Personality Traits</h3>
                  <div className="space-y-4">
                    {/* Tone */}
                    <div>
                      <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        Tone
                      </label>
                      <select
                        value={personality.tone}
                        onChange={(e) => handlePersonalityChange('tone', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-md text-sm ${
                          darkMode 
                            ? 'bg-gray-600 border-gray-500 text-white' 
                            : 'bg-white border-gray-300 text-gray-900'
                        }`}
                      >
                        <option value="friendly">Friendly</option>
                        <option value="professional">Professional</option>
                        <option value="casual">Casual</option>
                        <option value="formal">Formal</option>
                        <option value="warm">Warm</option>
                        <option value="neutral">Neutral</option>
                      </select>
                    </div>

                    {/* Formality */}
                    <div>
                      <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        Formality Level
                      </label>
                      <select
                        value={personality.formality}
                        onChange={(e) => handlePersonalityChange('formality', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-md text-sm ${
                          darkMode 
                            ? 'bg-gray-600 border-gray-500 text-white' 
                            : 'bg-white border-gray-300 text-gray-900'
                        }`}
                      >
                        <option value="very-formal">Very Formal</option>
                        <option value="formal">Formal</option>
                        <option value="moderate">Moderate</option>
                        <option value="casual">Casual</option>
                        <option value="very-casual">Very Casual</option>
                      </select>
                    </div>

                    {/* Warmth */}
                    <div>
                      <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        Warmth
                      </label>
                      <select
                        value={personality.warmth}
                        onChange={(e) => handlePersonalityChange('warmth', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-md text-sm ${
                          darkMode 
                            ? 'bg-gray-600 border-gray-500 text-white' 
                            : 'bg-white border-gray-300 text-gray-900'
                        }`}
                      >
                        <option value="very-warm">Very Warm</option>
                        <option value="warm">Warm</option>
                        <option value="moderate">Moderate</option>
                        <option value="cool">Cool</option>
                        <option value="neutral">Neutral</option>
                      </select>
                    </div>

                    {/* Enthusiasm */}
                    <div>
                      <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        Enthusiasm
                      </label>
                      <select
                        value={personality.enthusiasm}
                        onChange={(e) => handlePersonalityChange('enthusiasm', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-md text-sm ${
                          darkMode 
                            ? 'bg-gray-600 border-gray-500 text-white' 
                            : 'bg-white border-gray-300 text-gray-900'
                        }`}
                      >
                        <option value="very-enthusiastic">Very Enthusiastic</option>
                        <option value="enthusiastic">Enthusiastic</option>
                        <option value="moderate">Moderate</option>
                        <option value="calm">Calm</option>
                        <option value="reserved">Reserved</option>
                      </select>
                    </div>

                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-700/40">
                {hasUnsavedChanges && (
                  <button
                    onClick={saveChanges}
                    disabled={isSaving}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                      isSaving
                        ? 'bg-gray-400 cursor-not-allowed text-white'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                    }`}
                  >
                    {isSaving ? (
                      <>
                        <RefreshCw size={16} className="animate-spin" />
                        <span>Saving...</span>
                      </>
                    ) : (
                      <>
                        <Check size={16} />
                        <span>Save Changes</span>
                      </>
                    )}
                  </button>
                )}
                <div className="ml-auto">
                  <button 
                    onClick={() => setShowIntegrationPopup(false)}
                    className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Knowledge Base Popup */}
      {showCustomizationPopup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className={`bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 max-w-4xl w-full max-h-[90vh] overflow-y-auto mx-auto`}>
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <div className="w-10"></div>
                <h2 className={`text-2xl font-bold tracking-tight text-gray-900 dark:text-white`}>Knowledge Base</h2>
                <button 
                  onClick={() => setShowCustomizationPopup(false)}
                  className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                >
                  <X size={24} className={darkMode ? 'text-gray-300' : 'text-gray-600'} />
                </button>
              </div>

              <div className="space-y-6">
                {/* Instructions */}
                <div className={`bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 rounded-xl border p-4`}>
                  <div className="flex items-start gap-3">
                    <AlertCircle size={20} className={`${darkMode ? 'text-blue-400' : 'text-blue-600'} mt-0.5 flex-shrink-0`} />
                    <div>
                      <h3 className={`font-semibold mb-1 ${darkMode ? 'text-blue-300' : 'text-blue-900'}`}>
                        Upload Knowledge Base Files
                      </h3>
                      <p className={`text-sm ${darkMode ? 'text-blue-200' : 'text-blue-800'}`}>
                        Upload up to 5 PDF files containing key information for your chatbot. These documents will be used to train and inform the chatbot's responses. Include important details about your business, services, policies, and frequently asked questions.
                      </p>
                    </div>
                  </div>
                </div>

                {/* File Upload */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <h3 className={`font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Upload PDF Files</h3>
                  <div className="space-y-4">
                    <div>
                      <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        Select PDF files (up to 5 files, {knowledgeBase.files.length}/5 uploaded)
                      </label>
                      <input
                        type="file"
                        accept=".pdf"
                        multiple
                        onChange={handleFileUpload}
                        disabled={knowledgeBase.files.length >= 5}
                        className={`w-full px-3 py-2 border rounded-md text-sm ${
                          darkMode 
                            ? 'bg-gray-600 border-gray-500 text-white' 
                            : 'bg-white border-gray-300 text-gray-900'
                        } ${knowledgeBase.files.length >= 5 ? 'opacity-50 cursor-not-allowed' : ''}`}
                      />
                    </div>

                    {/* Uploaded Files List */}
                    {knowledgeBase.files.length > 0 && (
                      <div className="space-y-2">
                        <h4 className={`text-sm font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`}>Uploaded Files:</h4>
                        {knowledgeBase.files.map((file) => (
                          <div key={file.id} className={`${darkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} rounded border p-3 flex items-center justify-between`}>
                            <div className="flex items-center gap-3">
                              <FileText size={20} className="text-red-500" />
                              <div>
                                <p className={`text-sm ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                                  {file.url ? (
                                    <a href={file.url} target="_blank" rel="noopener noreferrer" className="underline hover:opacity-80">
                                      {file.name}
                                    </a>
                                  ) : (
                                    file.name
                                  )}
                                </p>
                                <p className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                  {(((file.size || 0) / 1024) / 1024).toFixed(2)} MB
                                </p>
                              </div>
                            </div>
                            <button
                              onClick={() => removeFile(file.id)}
                              className="p-1 text-red-500 hover:bg-red-100 dark:hover:bg-red-900 rounded"
                            >
                              <Trash2 size={16} />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                    {isUploadingKnowledge && (
                      <p className={`mt-2 text-sm ${darkMode ? 'text-blue-300' : 'text-blue-600'}`}>
                        Uploading files...
                      </p>
                    )}
                  </div>
                </div>

                {/* Website Toggle */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <Globe size={24} className="text-blue-500" />
                      <div>
                        <h3 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Add Website to Knowledge Base</h3>
                        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Include your website content in the knowledge base</p>
                      </div>
                    </div>
                    <button
                      onClick={() => handleWebsiteToggle(!knowledgeBase.addWebsite)}
                      className={`w-12 h-6 rounded-full transition-colors ${
                        knowledgeBase.addWebsite 
                          ? 'bg-green-500' 
                          : 'bg-gray-300 dark:bg-gray-600'
                      }`}
                    >
                      <div className={`w-5 h-5 bg-white rounded-full transition-transform ${
                        knowledgeBase.addWebsite ? 'translate-x-6' : 'translate-x-0.5'
                      }`} />
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-700/40">
                {hasUnsavedChanges && (
                  <button
                    onClick={saveChanges}
                    disabled={isSaving}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                      isSaving
                        ? 'bg-gray-400 cursor-not-allowed text-white'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                    }`}
                  >
                    {isSaving ? (
                      <>
                        <RefreshCw size={16} className="animate-spin" />
                        <span>Saving...</span>
                      </>
                    ) : (
                      <>
                        <Check size={16} />
                        <span>Save Changes</span>
                      </>
                    )}
                  </button>
                )}
                <div className="ml-auto">
                  <button 
                    onClick={() => setShowCustomizationPopup(false)}
                    className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Post Chat Popup */}
      {showPostChatPopup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className={`bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 max-w-4xl w-full max-h-[90vh] overflow-y-auto mx-auto`}>
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <div className="w-10"></div>
                <h2 className={`text-2xl font-bold tracking-tight text-gray-900 dark:text-white`}>Post Chat Information</h2>
                <button 
                  onClick={() => setShowPostChatPopup(false)}
                  className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                >
                  <X size={24} className={darkMode ? 'text-gray-300' : 'text-gray-600'} />
                </button>
              </div>

              <div className="space-y-6">
                {/* Instructions */}
                <div className={`bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 rounded-xl border p-4`}>
                  <div className="flex items-start gap-3">
                    <AlertCircle size={20} className={`${darkMode ? 'text-blue-400' : 'text-blue-600'} mt-0.5 flex-shrink-0`} />
                    <div>
                      <h3 className={`font-semibold mb-1 ${darkMode ? 'text-blue-300' : 'text-blue-900'}`}>
                        Configure Post Chat Information Fields
                      </h3>
                      <p className={`text-sm ${darkMode ? 'text-blue-200' : 'text-blue-800'}`}>
                        Define the information fields you want to collect after each chat. Each field requires a label and a field type.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Info Rows */}
                <div className={`rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-4`}>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Information Fields</h3>
                    <button
                      onClick={addPostChatInfoRow}
                      className={`px-4 py-2 rounded-md text-sm ${darkMode ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}
                    >
                      <Plus size={16} className="inline mr-1" />
                      Add Field
                    </button>
                  </div>

                  <div className="space-y-3">
                    {postChatInfo.map((row) => (
                      <div key={row.id} className={`${darkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} rounded border p-4`}>
                        <div className="space-y-4">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                Label
                              </label>
                              <input
                                type="text"
                                value={row.label}
                                onChange={(e) => updatePostChatInfoRow(row.id, 'label', e.target.value)}
                                placeholder={row.id === 1 ? 'Client Name' : row.id === 2 ? 'Interest' : row.id === 3 ? 'Chat Summary' : 'Enter label'}
                                className={`w-full px-3 py-2 border rounded-md text-sm ${
                                  darkMode 
                                    ? 'bg-gray-600 border-gray-500 text-white' 
                                    : 'bg-white border-gray-300 text-gray-900'
                                }`}
                              />
                            </div>
                            <div>
                              <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                Type
                              </label>
                              <div className="flex items-center gap-2">
                                <select
                                  value={row.type}
                                  onChange={(e) => updatePostChatInfoRow(row.id, 'type', e.target.value)}
                                  className={`flex-1 px-3 py-2 border rounded-md text-sm ${
                                    darkMode 
                                      ? 'bg-gray-600 border-gray-500 text-white' 
                                      : 'bg-white border-gray-300 text-gray-900'
                                  }`}
                                >
                                  <option value="Text">Text</option>
                                  <option value="Yes/No">Yes/No</option>
                                  <option value="Number">Number</option>
                                </select>
                                {postChatInfo.length > 1 && (
                                  <button
                                    onClick={() => removePostChatInfoRow(row.id)}
                                    className="p-2 text-red-500 hover:bg-red-100 dark:hover:bg-red-900 rounded"
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              checked={row.required}
                              onChange={(e) => updatePostChatInfoRow(row.id, 'required', e.target.checked)}
                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <label className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                              Required
                            </label>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-700/40">
                {hasUnsavedChanges && (
                  <button
                    onClick={saveChanges}
                    disabled={isSaving}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                      isSaving
                        ? 'bg-gray-400 cursor-not-allowed text-white'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                    }`}
                  >
                    {isSaving ? (
                      <>
                        <RefreshCw size={16} className="animate-spin" />
                        <span>Saving...</span>
                      </>
                    ) : (
                      <>
                        <Check size={16} />
                        <span>Save Changes</span>
                      </>
                    )}
                  </button>
                )}
                <div className="ml-auto">
                  <button 
                    onClick={() => setShowPostChatPopup(false)}
                    className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      </div>
    </div>
  );
};

export default Chatbot;
